
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "commitHash": "b357541c90c2168d48216d62a07de5dd3baab9a0",
    "version": "17.0.0"
};
